"use client"
import { useRouter } from "next/navigation"
import React, { memo } from "react"
import { usePermission } from "../hooks/usePermission"
export interface PermissionProps {
  children: React.ReactNode
  allow: string[]
  blackList?: string[]
  fallback?: React.ReactNode
  redirect?: string
}

/**
 * Permission wrapper to check if the user has the required permissions
 * @param children - the children to render if the user has the required permissions
 * @param allow - the permissions or roles to check for
 * @param blackList - the permissions or roles to exclude (higher priority than allow)
 * @param fallback - the fallback component to render if the user does not have the required permissions
 * @param redirect - the redirect path if the user does not have the required permissions
 */
export const Permission = memo((props: PermissionProps) => {
  const { children, allow, blackList, fallback, redirect } = props
  const { hasAccess } = usePermission()
  const router = useRouter()
  const enabled = hasAccess(allow, blackList)
  if (enabled) return children
  if (redirect) {
    router.push(redirect)
    return null
  }
  return fallback
})
Permission.displayName = "Permission"
